// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"304":"dd585a4e","559":"a8231b16","801":"5582465b","806":"49332865","973":"70efcbcf"}[chunkId] + ".css";
};